enum EPaymentMethodId {
    // WorldPay = 'worldpay',
    Checkout = 'checkout',
}

type TPaymentMethodDetail = {
    id: EPaymentMethodId
    name: string
    iconSrc: string
    paymentMethodLabel: string
    isEnabled: boolean
}

const SRC_ICONS = '/images/icons'

const paymentMethodDetailsRecord = {
    // [EPaymentMethodId.WorldPay]: {
    //     id: EPaymentMethodId.WorldPay,
    //     name: 'WorldPay',
    //     iconSrc: `${SRC_ICONS}/worldpay.png`,
    //     paymentMethodLabel: 'Credit/Debit Card',
    //     isEnabled: false,
    // },
    [EPaymentMethodId.Checkout]: {
        id: EPaymentMethodId.Checkout,
        name: 'Checkout',
        iconSrc: `${SRC_ICONS}/checkout.png`,
        paymentMethodLabel: 'Credit/Debit Card',
        isEnabled: true,
    },
} as Record<EPaymentMethodId, TPaymentMethodDetail>

export type { TPaymentMethodDetail }
export { EPaymentMethodId, paymentMethodDetailsRecord }
